import React from 'react';
import { Switch } from 'react-router-dom';
import ProtectedRoute from '../../utils/ProtectedRoute';
import YourProperties from './yourProperties/YourProperties';
import Dashboard from './dashboard/Dashboard';
import '../../stylesheets/stylesLayout/private.scss';
import AriPage from '../formsProperty/Ari/AriPage';
import TermsAndConditionsPopUp from '../../popups/TermsAndConditionsPopUp';
import routes from '../../utils/commonVariables/routes';
import OwnerPortalContainer from '../../layout/ownerPortalContainer/OwnerPortalContainer';
import AccountContainer from '../../accountSection/AccountContainer';
import Bookings from './yourBookings/Bookings';
import { ProviderTermsAndConditions } from '../../contexts/TermsAndConditionsContext';
import ZinantisContainer from './zinantis/ZinantisContainer';
import { ProviderZinantisMembers } from '../contextsProperty/ContextZinantisMembers';
import { useHotelOwner } from '../../contexts/HotelOwnerContext';

function OwnerPortalContainerMain({ match }) {
    const { ownerData } = useHotelOwner();
    return (
        <>
            <Switch>
                <ProtectedRoute
                    path={`${match.path}/your-properties`}
                    render={() => (
                        <OwnerPortalContainer>
                            <YourProperties />
                        </OwnerPortalContainer>
                    )}
                />
                <ProtectedRoute
                    path={`${match.path}/your-bookings`}
                    render={props => (
                        <OwnerPortalContainer>
                            <Bookings {...props} />
                        </OwnerPortalContainer>
                    )}
                />
                <ProtectedRoute
                    exact
                    path={`${match.path}/ari`}
                    render={() => (
                        <OwnerPortalContainer>
                            <AriPage />
                        </OwnerPortalContainer>
                    )}
                />
                <ProtectedRoute
                    path={match.path + routes.accountSection}
                    render={routerProps => (
                        <AccountContainer {...routerProps} />
                    )}
                />
                <ProtectedRoute
                    path={match.path + routes.zinantisSection}
                    render={routerProps => (
                        <OwnerPortalContainer>
                            <ProviderZinantisMembers>
                                <ZinantisContainer {...routerProps} />{' '}
                            </ProviderZinantisMembers>
                        </OwnerPortalContainer>
                    )}
                />
                <ProtectedRoute
                    exact
                    path={`${match.path}`}
                    render={() => (
                        <OwnerPortalContainer>
                            <Dashboard />
                        </OwnerPortalContainer>
                    )}
                />
            </Switch>
            {ownerData && !ownerData.signed ? (
                <ProviderTermsAndConditions>
                    <TermsAndConditionsPopUp />
                </ProviderTermsAndConditions>
            ) : null}
        </>
    );
}

export default OwnerPortalContainerMain;
